import { useSyncExternalStore } from 'react'
import { VolumeX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  ALERT_SOUND_BUTTON_ATTR, isAlertSoundReady, isAlertSoundSupported, playAlertSound, subscribeAlertSound,
  unlockAlertSound,
} from '@/lib/alertSound'

// #295 — shown only while the browser keeps the alert chime blocked (until the user has touched the
// page). One click turns the sound on and plays the chime once, so the user hears what an alert sounds
// like; the button then goes away. Not shown where Web Audio is missing: a click could not help.
// The page-wide unlock listener plays that chime (the button is gone before its own click arrives);
// onClick is the fallback, and the chime's 1.5 s throttle keeps it to one. A short word sits next to
// the icon from sm: up, so it is seen; phones get the icon, with the full text as its name.
export function AlertSoundButton() {
  const { t } = useTranslation('common')
  const ready = useSyncExternalStore(subscribeAlertSound, isAlertSoundReady, () => false)
  if (ready || !isAlertSoundSupported()) return null
  const label = t('header.soundOff')
  return (
    <Button
      variant="ghost"
      size="icon"
      {...{ [ALERT_SOUND_BUTTON_ATTR]: '' }}
      onClick={() => { void unlockAlertSound().then((on) => { if (on) playAlertSound() }) }}
      className="h-8 w-8 gap-1.5 rounded-lg text-destructive hover:text-destructive hover:bg-destructive/10 transition-colors sm:w-auto sm:px-2"
      title={label}
      aria-label={label}
    >
      <VolumeX className="h-4 w-4" />
      <span data-sound-off-word className="hidden text-xs font-medium sm:inline">{t('header.soundOffShort')}</span>
    </Button>
  )
}
